export default __webpack_public_path__ + "static/media/logo.7fd8d98c.svg";